/* eslint-disable max-len */
import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AngularFirestore } from '@angular/fire/firestore';
import { ModalController, NavController, ToastController } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationsService } from 'src/app/services/notifications.service';
import { LedgerService } from 'src/app/services/ledger.service';
import { environment } from 'src/environments/environment';
import { ShareService } from 'src/app/services/share.service';
import { DocumentViewerComponent } from '../document-viewer/document-viewer.component';
import { readAndCompressImage } from 'browser-image-resizer';
import { AngularFireStorage } from '@angular/fire/storage';
import firebase from 'firebase/app';
import 'firebase/storage';
import 'firebase/firestore';

@Component({
  selector: 'app-article',
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.scss'],
})
export class ArticleComponent implements OnInit {

  id;
  article;
  unsub;
  comment = '';
  currentUser = this.authService.currentUser;
  unsub1;
  tfModel;
  isCommenting = false;
  commentImage;
  canViewAnswer = false;
  storage = firebase.storage();

  constructor(
    public firestore: AngularFirestore,
    public authService: AuthService,
    public route: ActivatedRoute,
    public router: Router,
    public toastController: ToastController,
    public navController: NavController,
    public notificationsService: NotificationsService,
    public modalController: ModalController,
    public ledgerService: LedgerService,
    public shareService: ShareService,
  ) {
    if (this.route.snapshot.params.id) {
      this.id = this.route.snapshot.params.id;
    }
    this.unsub1 = this.authService.currentAccount.subscribe(async (currentUser) => { this.currentUser = currentUser; });

  }

  ionViewDidEnter() {
    this.getArticle();
  }

  ngOnInit() {
    console.log(this.id);

  }

  share() {
    this.shareService.share(this.article?.searchList?.substring(0, 150), this.article.title, this.article.images, environment.siteUrl + 'article/' + this.article.id);
  }

  backBtn() {
    this.navController.back();
  }

  async getArticle() {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    this.unsub = this.firestore.collection('articles').doc(this.id).snapshotChanges().subscribe(async (doc) => {
      this.article = undefined;
      console.log('Current data: ', doc.payload.data());
      this.article = { id: doc.payload.id, ...(doc.payload.data() as any) };
      if (this.article.user) {
        this.article.user = await this.authService.getUserById(this.article.user);
      }
      if (Array.isArray(this.article?.comments)) {
        for (const comment of this.article.comments) {
          if (comment.user) {
            comment.user = await this.authService.getUserById(comment.user);
          }
        }
      }
    });
  }

  async like() {
    if (!this.article?.likes?.length) { this.article.likes = []; }
    const docRef = this.firestore.collection('articles').doc(this.article.id);
    if (this.article?.likes?.includes(this.currentUser.id)) {
      // this.article.likes.splice(this.article.likes.indexOf(this.currentUser.id), 1);
      // docRef.update({
      //   likes: firebase.firestore.FieldValue.arrayRemove(this.currentUser.id)
      // }).then(async () => {
      //   const docSnap = await docRef.get().toPromise();
      //   if (docSnap.exists) {
      //     const article = { id: docSnap.id, ...((docSnap.data() as any) || {}) };
      //     this.article = article;
      //   }
      // });
    } else {
      this.article.likes.push(this.currentUser.id);
      docRef.update({
        likes: firebase.firestore.FieldValue.arrayUnion(this.currentUser.id)
      }).then(async () => {
        const docSnap = await docRef.get().toPromise();
        if (docSnap.exists) {
          const article = { id: docSnap.id, ...((docSnap.data() as any) || {}) };
          this.article = article;
          this.notificationsService.sendNotification(this.currentUser.displayName + ' has liked your post ' + this.article.type, this.article.content, {
            notificationToken: this.article.user.notificationToken,
            type: 'notification',
            by: this.currentUser.id,
            to: this.article.user.id,
            redirectURL: '/article/' + article.id
          }, this.article?.images?.length > 0 ? this.article?.images[0] : undefined, undefined, undefined);
        }
      });
    }

  }

  async addComment() {
    if (this.comment && this.comment.length > 0) {
      this.isCommenting = true;

      const documentUuid = this.firestore.createId();

      const comment = {
        user: this.authService.currentUser.id,
        comment: this.comment,
        commentImage: this.commentImage,
        timestamp: new Date(),
        id: documentUuid,
      };
      Object.keys(comment).forEach(key => {
        if (comment[key] === undefined || comment[key] === null) {
            delete comment[key];
        }
    });
      const docRef = this.firestore.collection('articles').doc(this.id);
      // Atomically add a new region to the "regions" array field.
      await docRef.update({
        comments: firebase.firestore.FieldValue.arrayUnion(comment)
      }).then(() => {
        this.notificationsService.sendNotification(this.currentUser.displayName + ' has commented on your ' + this.article.type, this.article.content, {
          notificationToken: this.article.user.notificationToken,
          type: 'notification',
          by: this.currentUser.id,
          to: this.article.user.id,
          redirectURL: '/article/' + this.article.id
        }, this.article?.images?.length > 0 ? this.article?.images[0] : undefined, undefined, undefined);
      });
      this.comment = '';
      this.commentImage = undefined;
      const docSnap = await docRef.get().toPromise();
      if (docSnap.exists) {
        const article: any = { id: docSnap.id, ...((docSnap.data() as any) || {}) };
        this.article = article;
        this.isCommenting = false;
        this.presentToast('Successfully Posted!');
      }
    } else {
      this.presentToast('Please write a comment!');
    }
  }


  markCorrect(id) {
    const docRef = this.firestore.collection('articles').doc(this.article.id);
    const correctAnsComment = this.article.comments.find((x) => x.id = id);
    docRef.update({
      correctAnswer: id
    });
    this.ledgerService.addUserLedger({ user: correctAnsComment.user.id, message: 'Coins earned with answer!', value: 1 });
  }

  viewAnswer(correctAnswer) {
    const correctAnsComment = this.article.comments.find((x) => x.id = correctAnswer);
    this.ledgerService.addUserLedger({ user: this.authService.currentUser.id, message: 'Answer in Available to View!', value: -2 }).then(() => {
      this.canViewAnswer = true;
    });
    this.ledgerService.addUserLedger({ user: correctAnsComment.user.id, message: 'Coins earned with answer!', value: 1 });
  }

  getImage() {
    document.getElementById('comment-image-input').click();
  }

  readFile(event) {
    this.isCommenting = true;
    const imageConfig = {
      quality: 1,
      maxWidth: 1080,
      maxHeight: 1080,
      autoRotate: true,
      debug: false,
      mimeType: 'image/jpeg'
    };
    if (event.target.files && event.target.files[0]) {
      readAndCompressImage(event.target.files[0], imageConfig)
        .then(resizedImage => {
          console.log(resizedImage);
          // eslint-disable-next-line max-len
          const storageRef = this.storage.ref( 'commentImages/' + this.authService.currentUser.uid + '_' + Math.random().toString(36).substring(2, 9));
          // 'file' comes from the Blob or File API
          storageRef.put(resizedImage).then((snapshot) => {
            console.log('Uploaded a blob or file!', snapshot);
            snapshot.ref.getDownloadURL().then((downloadURL) => {
              console.log('File available at', downloadURL);
              console.log(this.commentImage);
              this.commentImage = downloadURL;
              this.isCommenting = false;
            });
          });
        }).catch(err => {
          console.log(err);
          this.isCommenting = false;
        });
    } else {
      this.isCommenting = false;
    }
  }

  purchaseFile(coin, i) {
    const file = this.article.files[i];

    this.ledgerService.addUserLedger({ user: this.authService.currentUser.id, message: 'Downloading Cost!', value: coin }).then(() => {
      this.downloadFile(file);
    });
    this.ledgerService.addUserLedger({ user: this.article.user.id, message: 'Coins earned with upload!', value: -1 * (coin) / 2 });
    if (!this.article?.docDownloadCounts) {
      this.article.docDownloadCounts = [];
    }
    this.article.docDownloadCounts[i] = this.article.docDownloadCounts[i] ? this.article.docDownloadCounts[i] + 1 : 1;
    console.log(this.article.docDownloadCounts);
    this.firestore.collection('articles').doc(this.id).update({
      docDownloadCounts: this.article.docDownloadCounts
    });
  }

  downloadFile(file) {
    const link: any = document.createElement('a');
    link.download = 'downlaod-sharesquare';
    link.href = file;
    link.visibility = 'hidden';
    link.setAttribute('target', '_blank');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  async openDocumentViewer(i) {
    const file = this.article.files[i];

    console.log(file);
    const modal = await this.modalController.create({
      component: DocumentViewerComponent,
      cssClass: 'document-viewer-modal',
      // initialBreakpoint: 0.8,
      // breakpoints: [0, 0.8, 1],
      componentProps: {
        file,
      }
    });

    await modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'viewed' && data) {
      if (!this.article?.docViewCounts) {
        this.article.docViewCounts = [];
      }
      this.article.docViewCounts[i] = this.article.docViewCounts[i] ? this.article.docViewCounts[i] + 1 : 1;
      console.log(this.article.docViewCounts);
      this.firestore.collection('articles').doc(this.id).update({
        docViewCounts: this.article.docViewCounts
      });
    }
  }

  async presentToast(message: string) {
    const toast = await this.toastController.create({
      message,
      duration: 3000,
      position: 'top',
    });
    toast.present();
  }

  ionviewDidLeave() {
    if (this.unsub) {this.unsub.unsubscribe();}
    if (this.unsub1) {this.unsub1.unsubscribe();}
  }

}


